import { Company } from './company';

interface ProfileView {
	id: string;
	admin: boolean;
	created_at: string;
	custom_properties: Record<string, string | null>;
	display_name: string;
	email: string;
	first_name: string;
	full_pic_url: string;
	has_manager: boolean;
	is_manager: boolean;
	last_name: string;
	locale: string;
	profile_pic_url: string;
	slug: string;
	status: string;
	super_admin: boolean;
	updated_at: string;
	user_mode: string;
	username: string;
}

interface NavView {
	company_admin: boolean;
	earning_balance: number;
	earning_balance_with_currency: string;
	finance_admin: boolean;
	giving_balance: number;
	global_admin: boolean;
	rewards_admin: boolean;
	show_analytics: boolean;
	show_awards: boolean;
	show_integrations: boolean;
	tech_admin: boolean;
}

export interface UserProfile extends ProfileView, NavView {}

export enum UserMode {
	Normal = 'normal',
	Benefactor = 'benefactor',
	Receiver = 'receiver',
	Observer = 'observer',
}

export type User = {
	id: string;
	admin: boolean;
	can_give: boolean;
	can_give_non_zero: boolean;
	can_receive: boolean;
	company: Company;
	company_admin: boolean;
	created_at: string;
	custom_properties: Record<string, string | null>;
	custom_feeds: CustomFeed[];
	direct_report_ids: string[];
	display_name: string;
	earning_balance: number;
	earning_balance_with_currency: string;
	email: string;
	preferred_first_name?: string;
	feed_preference: string;
	first_name: string;
	following?: Array<string>;
	full_pic_url: string;
	giving_balance: number;
	giving_balance_with_currency: string;
	has_manager: boolean;
	is_manager: boolean;
	last_name: string;
	locale: string;
	monthly_allowance: number;
	ppp_adjustment: number;
	profile_pic_url: string;
	redemption_rules?: RedemptionRule;
	show_awards: boolean;
	show_analytics: boolean;
	show_integrations: boolean;
	slug: string;
	status: string;
	suggested_give_amounts?: SuggestedGiveAmount[];
	user_mode: UserMode;
	username: string;
	all_usernames: string[];
};

export type SuggestedGiveAmount = {
	dataValue: number;
	name: string;
};

export type CustomFeed = {
	filter: string;
	option: {
		title: string;
		value: string;
	};
};

export type RedemptionRule = {
	message: string;
	redemption_allowed: boolean;
};
